import { Link } from "react-router-dom";
import FavoriteButton from "@/components/feature/FavoriteButton";

interface NewsCardProps {
  news: {
    id: string;
    title: string;
    category: string;
    date: string;
    author: string;
    excerpt: string;
    cover: string;
  };
  showExcerpt?: boolean;
}

export default function NewsCard({ news, showExcerpt = true }: NewsCardProps) {
  return (
    <article className="group flex gap-3.5 sm:gap-5">
      <Link
        to={`/news/${news.id}`}
        className="relative shrink-0 w-[112px] sm:w-44 lg:w-52 aspect-[16/10] rounded-lg overflow-hidden bg-background-200"
      >
        <img
          src={news.cover}
          alt={`${news.title} 配图`}
          title={`${news.title} 吴梦梦影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.05]"
        />
        <span className="absolute left-2 top-2 px-1.5 py-0.5 rounded bg-primary-950/70 backdrop-blur text-[10px] text-background-50 tracking-wide">
          {news.category}
        </span>
      </Link>

      <div className="flex flex-col min-w-0 flex-1 py-0.5">
        <div className="flex items-center gap-2 text-[11px] sm:text-xs text-foreground-500 font-label">
          <span>{news.date}</span>
          <span className="w-1 h-1 rounded-full bg-background-400" />
          <span className="truncate">{news.author}</span>
        </div>

        <h3 className="mt-1.5 sm:mt-2 text-[14px] sm:text-base font-semibold leading-snug text-foreground-950">
          <Link to={`/news/${news.id}`} className="line-clamp-2 hover:text-primary-600 transition-colors">
            {news.title}
          </Link>
        </h3>

        {showExcerpt && (
          <p className="mt-1.5 text-xs sm:text-sm text-foreground-600 leading-relaxed line-clamp-2 hidden sm:block">
            {news.excerpt}
          </p>
        )}

        <div className="mt-auto pt-2.5 flex items-center justify-between gap-3">
          <Link
            to={`/news/${news.id}`}
            className="text-[11px] sm:text-xs text-primary-600 hover:text-accent-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line text-xs leading-none" />
          </Link>
          <FavoriteButton
            variant="icon"
            item={{
              key: `news:${news.id}`,
              type: "news",
              id: news.id,
              title: news.title,
              cover: news.cover,
              meta: `${news.category} · ${news.date}`,
            }}
          />
        </div>
      </div>
    </article>
  );
}